// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card__title {\n  color: rgba(0, 0, 0, 0.87);\n}\n.card-option {\n  cursor: pointer !important;\n}\n.card-option:hover {\n  background: rgba(149, 193, 74, 0.08);\n  background: linear-gradient(90deg, rgba(149, 193, 74, 0.08) 25%, rgba(222, 225, 89, 0.08) 100%);\n}", ""]);
// Exports
module.exports = exports;
